import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Typography,
  Descriptions,
  Radio,
  Button,
  Card,
  Statistic,
  message,
  Tag,
  Spin,
 Result
} from "antd";
import {
  LeftOutlined,
  RightOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import actions from "../redux/examination/actions";
import config from "../Services/apiEndPoints";

const { Title } = Typography;

const ExamPaper = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const studentId = localStorage.getItem("Student_Id");
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const { examination, data, isFetching,singleanswer } = useSelector(
    (state) => state.Examination
  );
// if(singleanswer){
//   console.log(singleanswer[0].map(item => [item?.question_id, item?.attempted_answer]));
// }





  const initialDurationMinutes = parseInt(examination?.duration_minutes);
  const [remainingTime, setRemainingTime] = useState(
    initialDurationMinutes * 60
  );
  const testId=localStorage.getItem("testId")
  const [answers, setAnswers] = useState({});
  const questions = examination?.questions;
  const [startIndex, setStartIndex] = useState(0);
  const pageSize = 15;
  const displayedButtons = questions?.slice(startIndex, startIndex + pageSize);
  const [questionsStatus, setQuestionsStatus] = useState(
    questions ? questions.map(() => "unanswered") : []
  );

  const getExam = useCallback(() => {
    dispatch(actions.getallQuestions(`${config.exam}?studentId=${studentId}&testId=${testId}`));
    dispatch(actions.singleResult(`${config.singleanswers}?studentId=${studentId}&testId=${testId}`));
  }, []);

  useEffect(() => {
    getExam();
  }, [getExam]);



  const sumitedTestaftertime = () => {
    try {
      dispatch(actions.resetActionType());
        navigate(`/dashboard/examResults/id=${studentId}`);
      
    } catch (err) {
      console.log(err)
    }
  };

  useEffect(() => {
    if (!data || !data.tests || !data.tests[0]) {
      console.error("Data or exam test information is missing.");
      return;
    }

    const examStartTimeString = data.tests[0]?.exam_start_time;
    const examEndTimeString = data.tests[0]?.exam_end_time;

    if (examStartTimeString && examEndTimeString) {
      const examStartTime = new Date(examStartTimeString).getTime();
      const examEndTime = new Date(examEndTimeString).getTime();
      const currentTime = Date.now();

      if (isNaN(examStartTime) || isNaN(examEndTime)) {
        console.error("Invalid start or end time");
        return;
      }

      if (currentTime < examStartTime) {
        console.warn("Exam has not started yet.");
        setRemainingTime(0);
        return;
      }

      if (currentTime > examEndTime) {
        console.warn("Exam has already ended.");
        setRemainingTime(0);
        return;
      }

      const timeRemaining = Math.floor((examEndTime - currentTime) / 1000);
      setRemainingTime(timeRemaining);

      const timerInterval = setInterval(() => {
        setRemainingTime((prevTime) => {
          if (prevTime <= 0) {
            clearInterval(timerInterval);
            sumitedTestaftertime()
            console.warn("Exam time is over!");
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);

      return () => clearInterval(timerInterval);
    }
  }, [data]);

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      const newIndex = currentQuestionIndex - 1;
      setCurrentQuestionIndex(newIndex);
      setSelectedAnswer(answers[newIndex] || null);
      if (newIndex < startIndex) {
        setStartIndex((prevStartIndex) =>
          Math.max(prevStartIndex - pageSize, 0)
        );
      }
    }
  };

  const handleContinueNext = () => {
    if (!selectedAnswer) {
      message.error("Please select an answer before proceeding.");
      return;
    }
    try {
      const currentQuestion = questions?.[currentQuestionIndex];
      if (currentQuestion) {
        let payload = {
          exam_id: data?._id,
          question_paper_id: examination._id,
          student_id: studentId,
          question_id: currentQuestion?.question_id,
          question_name: currentQuestion?.question_text,
          attempted_answer: selectedAnswer,
          testId:testId
        };
        if (currentQuestionIndex === questions?.length - 1) {
          payload = {
            ...payload,
            is_submitted: true,
          };
          dispatch(actions.resetActionType());
        }
        dispatch(actions.sendAnswer(config.sendanswer, payload));
        const updatedStatus = [...questionsStatus];
        updatedStatus[currentQuestionIndex] = "answered";
        setQuestionsStatus(updatedStatus);
        setAnswers((prevAnswers) => ({
          ...prevAnswers,
          [currentQuestionIndex]: selectedAnswer,
        }));

        const newIndex = currentQuestionIndex + 1;
        if (newIndex >= startIndex + pageSize) {
          setStartIndex((prevStartIndex) => prevStartIndex + pageSize);
        }

        if (currentQuestionIndex < questions?.length - 1) {
          setCurrentQuestionIndex(newIndex);
          setSelectedAnswer(answers[newIndex] || null);
        } else {
          navigate(`/dashboard/examResults/id=${studentId}`);
        }
      }
    } catch (err) {}
  };

  const handleSkip = () => {
    const newIndex = currentQuestionIndex + 1;
    if (newIndex < questions?.length) {
      setCurrentQuestionIndex(newIndex);
      setSelectedAnswer(answers[newIndex] || null);
      const updatedStatus = [...questionsStatus];
      updatedStatus[currentQuestionIndex] = "skipped";
      setQuestionsStatus(updatedStatus);
      if (newIndex >= startIndex + pageSize) {
        setStartIndex((prevStartIndex) => prevStartIndex + pageSize);
      }
    }
  };

  const handleAnswerChange = (e) => {
    const answer = e.target.value;
    setSelectedAnswer(answer);
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [currentQuestionIndex]: answer,
    }));
  };

  const handleQuestionClick = (index) => {
    setCurrentQuestionIndex(index);
    setSelectedAnswer(
      questionsStatus?.[index] === "answered" ? answers[index] : null
    );
    if (index >= startIndex + pageSize || index < startIndex) {
      setStartIndex(Math.floor(index / pageSize) * pageSize);
    }
  };

  const handlePrevious1 = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - pageSize);
    }
  };

  const handleNext = () => {
    if (startIndex + pageSize < questions?.length) {
      setStartIndex(startIndex + pageSize);
    }
  };
  



  const currentQuestionId = questions?.[currentQuestionIndex]?.question_id;

  const attemptedAnswerObj = singleanswer?.find(
    (item) => item?.question_id === currentQuestionId
  );
  
  const attemptedAnswer = attemptedAnswerObj?.attempted_answer;
  // console.log(attemptedAnswer)

  useEffect(() => {
    if (attemptedAnswer !== undefined && selectedAnswer === null) {
      setSelectedAnswer(attemptedAnswer); 
    }
  }, [attemptedAnswer]);


  return (
    <>
      {isFetching ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 50,
                }}
                spin
              />
            }
          />
          <p>Loading...</p>
        </div>
      ) : (
        <div>
           {questions === undefined ? 
             <Result
             status="403"
             title="403"
             subTitle="Sorry, something went wrong"
           />
           :

        <Row
          justify="center"
          style={{ backgroundColor: "#f7f7f7", padding: "20px" }}
        >
          {/* Main Content */}
          <Col xs={24} sm={24} md={16} lg={14} xl={14}>
            <Card
              style={{
                width: "100%",
                padding: "20px",
                margin: "10px",
                borderRadius: "8px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                backgroundColor: "#ffffff",
              }}
            >
              <Title
                level={4}
                style={{
                  textAlign: "center",
                  margin: "0",
                  fontSize: "24px",
                  color: "#333",
                }}
              >
                {/* {data?.data[0]?.exam_name} */}
              </Title>
              <div style={{ marginBottom: "20px" }}>
                <Title
                  level={5}
                  style={{
                    wordWrap: "break-word",
                    fontSize: "18px",
                    color: "#444",
                  }}
                >
                  {`${currentQuestionIndex + 1}: ${
                    questions?.[currentQuestionIndex]?.question_text
                  }`}
                </Title>
                <Radio.Group
                  style={{ width: "100%" }}
                  value={selectedAnswer}
                  onChange={handleAnswerChange}
                >
                  {questions?.[currentQuestionIndex]?.options?.map(
                    (option, index) => (
                      <Radio
                        key={index}
                        value={option?.option_text}
                        style={{
                          display: "block",
                          margin: "5px 0",
                          width: "100%",
                        }}
                      >
                        <span
                          style={{ fontWeight: "bold", marginRight: "8px" }}
                        >
                          {String.fromCharCode(65 + index)}.
                        </span>{" "}
                        {option?.option_text}
                      </Radio>
                    )
                  )}
                </Radio.Group>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  gap: "15px",
                }}
              >
                <Button
                  type="default"
                  onClick={handlePrevious}
                  disabled={currentQuestionIndex === 0}
                  icon={<LeftOutlined />}
                  style={{ flexGrow: 1 }}
                >
                  Previous
                </Button>
                <Button
                  type="primary"
                  onClick={handleContinueNext}
                  style={{ flexGrow: 1 }}
                >
                  {currentQuestionIndex === questions?.length - 1
                    ? "Submit"
                    : "Save & Next"}{" "}
                  <RightOutlined />
                </Button>
                {currentQuestionIndex !== questions?.length - 1 && (
                  <Button
                    type="dashed"
                    onClick={handleSkip}
                    style={{ flexGrow: 1 }}
                  >
                    Skip Question
                  </Button>
                )}
              </div>
            </Card>
          </Col>

          <Col md={7}>
            <Card
              style={{
                marginTop: "10px",
                marginLeft: "10px",
                borderRadius: "8px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                backgroundColor: "#ffffff",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  marginBottom: "10px",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                Time Left
              </div>
              <Statistic.Countdown
                value={Date.now() + remainingTime * 1000}
                format="mm:ss"
                valueStyle={{
                  fontSize: "24px",
                  color: remainingTime <= 60 ? "red" : "#3f8600",
                  fontWeight: "bold",
                  textAlign: "center",  
                }}
              />
              <div
                style={{
                  marginBottom: "20px",
                  textAlign: "center",
                  fontSize: "12px",
                }}
              >
                <span>
                  Attempted:{" "}
                  {
                    questionsStatus?.filter((status) => status === "answered")
                      .length
                  }
                </span>
                <span style={{ margin: "0 10px" }}>|</span>
                <span>
                  Skipped:{" "}
                  {
                    questionsStatus?.filter((status) => status === "skipped")
                      .length
                  }
                </span>
                <span style={{ margin: "0 10px" }}>|</span>
                <span>
                  Remaining:{" "}
                  {
                    questionsStatus?.filter((status) => status === "unanswered")
                      .length
                  }
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
              >
                <Button
                  icon={<LeftOutlined />}
                  onClick={handlePrevious1}
                  disabled={startIndex === 0}
                  style={{ marginRight: "8px" }}
                >
                  Previous
                </Button>
                <Button
                  icon={<RightOutlined />}
                  onClick={handleNext}
                  disabled={startIndex + pageSize >= questions?.length}
                >
                  Next
                </Button>
              </div>
              {displayedButtons?.map((_, index) => (
                <Button
                  key={index}
                  type="dashed"
                  shape="circle"
                  style={{
                    width: "35px",
                    height: "35px",
                    margin: "5px",
                    backgroundColor:
                      questionsStatus?.[startIndex + index] === "answered"
                        ? "#4CAF50"
                        : questionsStatus?.[startIndex + index] === "skipped"
                        ? "#FF9800"
                        : "#E0E0E0",
                    color: "#FFFFFF",
                  }}
                  onClick={() => handleQuestionClick(startIndex + index)}
                >
                  {startIndex + index + 1}
                </Button>
              ))}
              <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
                <Tag color="green">Answered</Tag>
                <Tag color="orange">Skipped</Tag>
                <Tag color="#E0E0E0">Not Answered</Tag>
              </div>
            </Card>
          </Col>
        </Row>
}
        </div>
      )}
    </>
  );
};

export default ExamPaper;
